import {
  Button,
  Dialog,
  Grid,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useAppSelector } from "../../../redux/hooks";
import theme from "../../../theme";
import useButtonStyles from "../../../styles/useButtonStyles";

interface exportProps {
  open: boolean;
  handleClose: any;
  emailSent: boolean;
  handleSendExport: Function;
  exportTitle: string;
  sending: boolean;
  closeDialog: Function;
}
const ExportDialog = (props: exportProps) => {
  const buttonStyles = useButtonStyles();
  const adminEmail = useAppSelector(
    (state: any) => state.persistReducers.login.email
  );
  const {
    open,
    handleClose,
    emailSent,
    handleSendExport,
    exportTitle,
    sending,
    closeDialog,
  } = props;
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "8px",
        },
      }}
    >
      <Grid p={4} display={"flex"} flexDirection={"column"} gap={2}>
        <Typography
          sx={{
            fontFamily: theme.font?.fontFamily.primary,
            fontSize: theme.font?.fontSize.large,
          }}
        >
          The {exportTitle} list will be sent to {adminEmail}
        </Typography>
        {emailSent && (
          <Typography variant="body1" color="primary">
            Email sent successfully!
          </Typography>
        )}
        <Grid display={"flex"} gap={2} mt={2}>
          <Button
            sx={{
              ...buttonStyles.outlinedSecondary,
              width: "50%",
            }}
            onClick={() => closeDialog(false)}
          >
            Cancel
          </Button>
          <Button
            sx={{
              ...buttonStyles.containedSecondary,
              width: "50%",
              cursor: sending ? "not-allowed" : "pointer",
            }}
            onClick={() => handleSendExport()}
          >
            {sending ? <CircularProgress size={20} /> : "Send"}{" "}
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default ExportDialog;
